import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Welcome!{" "}
              <span className="purple"> Thanks for connecting with me! </span>
            </h1>
            <p className="home-about-body">
              {" "}
              I'm <span className="purple">Mohamed Al-Omairi </span> - a
              developer from{" "}
              <span className="purple"> Metro Detroit. 🧑🏻‍💻🌆</span>
              <br />
              <br></br>I love soccer, bleeding-edge technology, and personal
              fitness. <br></br>I like to combine some of my interests with my
              technical skills to create fun, unique apps that anyone can enjoy!
              <br /> ☕ + 👨🏻‍💻 = 😁
              <br></br>I am especially passionate about crafting solutions that
              make life easier.<br></br> Head over to my Projects page to see
              what I have been working on!
              <br />
              <br />
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Connect with me</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/mozyn"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/mohamed-al-omairi/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:moealomairi@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
